import axios from "@/http"
export default {
  name:"webIndex",
  wxLogin(data){
    return axios({
      method:'GET',
      url:"/api/backstage/v1/sys/wxLogin",
      params:data
    })
  },
  BindingWechat(data){
    return axios({
      method:'POST',
      url:"/api/backstage/v1/sys/BindingWechat",
      data:data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/axj-web/axj-web-index-api.js